<app-spinner-container [isLoading]="tableCommunPortailComponent?.exportReportsBtnsComponent?.isLoading " [diametre]="65">

    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">


        <mat-card-header class="titree">
            {{etatDetails.cardTitle | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">
            <app-table-commun-portail #tableCommunPortailComponent page="tableEtatEdition" [data]="etatDetails.data"></app-table-commun-portail>
        </mat-card-content>
    </mat-card>
</app-spinner-container>
